import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";

const clientTableSetting = Vue.use(
  ClientTable,
  {
    //options
    sortable: ["id"],
    filterable: ["id", "title", "phone"],
    pagination: {
      chunk: 5,
      edge: false,
      nav: "scroll"
    },
    sortIcon: {
      base: "fa",
      up: "fa-sort-asc",
      down: "fa-sort-desc",
      is: "fa-sort"
    },
    texts: {
      count:
        "Showing {from} to {to} of {count} records|{count} records|One record",
      first: "First",
      last: "Last",
      filter: "Filter:",
      filterPlaceholder: "Search query",
      limit: "Records:",
      page: "Page:",
      noResults: "Малумот мавжуд эмас", //No matching records
      filterBy: "Filter by {column}",
      loading: "Loading...",
      defaultOption: "Select {column}",
      columns: "Columns"
    }
  },
  false,
  "bootstrap4"
);

export default clientTableSetting;
